export default __webpack_public_path__ + "static/media/bronze.09432a38.svg";